import React from "react";
import InlineHelpTooltip from "../InputField/InlineHelpTooltip";

const BrokerHelpTooltip = ({ content }) => {
  if (!content) return null;
  return <InlineHelpTooltip content={content} className="broker-help-tooltip" align="right" />;
};

export default BrokerHelpTooltip;
